/*
* 异常统计上报
* */
import { request } from './request.js';
import { BOM } from './BOM.js';
import { GameLog } from './Game.js';
import { UNIQUE_DEVICE_COOKIE_NAME } from './config.js';
import {
    getPokeUser,
    isNative,
    trackServer,
    getWebUniqueDeviceId,
    getWebUser,
    setWebUser,
    getUrlStrs,
    getPageUrlInfo
} from './utils.js';
import { getMyUserInfo } from './FilterItems.js';

let now = null;

//
function generateExtraParams() {
    const url = BOM.window.location.href.substring(0, 200);
    const device_id = getWebUniqueDeviceId();

    const params = {
        url,
        timestamp: new Date().getTime()
    };
    if (device_id) {
        params.device_id = device_id;
    }
    return params;
}
// TalkingData事件上报
function onTalkingDataEvent(event, label, extra = {}) {
    if(!isNative()) {
        if(BOM.window.TDAPP && BOM.window.TDAPP.onEvent) {
            BOM.window.TDAPP.onEvent(event, label, extra);
        } else {
            setTimeout(() => {
                onTalkingDataEvent(event, label, extra);
            },5000)
        }
    }
}

//
async function onEvent(event, label, extra = {}) {
    const extraParams = generateExtraParams();
    //说明没初始化
    if (!extraParams.device_id) {
        return;
    }
    const _extra = {
        ...extra
    };
    const webUserInfo = getWebUser();
    let loginUser = webUserInfo.webUser;
    //如果没有用户信息，获取用户信息
    if (!webUserInfo.webUserLoaded) {
        loginUser = await getMyUserInfo();
        setWebUser(loginUser);
    }
    //
    if (loginUser) {
        _extra.uid = loginUser.uid;
    }
    const urlParams = getUrlStrs();
    if (urlParams.unique_device_id) {
        _extra.unique_device_id = urlParams.unique_device_id;
    }
    await onEvents([{ event, label, extra: _extra, ...extraParams }]);
}

//
function onEvents(data_array) {
    return new BOM.window.Promise((resolve) => {
        request({
            url: '/service/web_log/report/',
            method: 'post',
            json: true,
            log: false,
            needNetworkError: false,
            error: () => {
            },
            data: {
                data: data_array
            },
            callback: (data) => {
                resolve()
            }
        });
    })
}

function onEventsBeacon(data_array) {
    if (BOM.window.navigator && BOM.window.navigator.sendBeacon) {
        const data = JSON.stringify({ data:data_array });
        const blob = new Blob([data], { type: 'application/json' });
        navigator.sendBeacon("https://api.pokekara.com/service/web_log/report/", blob);
    }
}

function onEventBeacon(event, label, extra = {}) {
    const extraParams = generateExtraParams();
    //说明没初始化
    if (!extraParams.device_id) {
        return;
    }
    const _extra = {
        ...extra
    };
    const urlParams = getUrlStrs();
    if (urlParams.unique_device_id) {
        _extra.unique_device_id = urlParams.unique_device_id;
    }
    onEventsBeacon([{ event, label, extra: _extra, ...extraParams }]);
}



function _log(data, proxy = true) {
    const _pokeUser = getPokeUser();
    if (!data.uid) {
        data.uid = _pokeUser.uid || 'nologin';
    }
    if (isNative() && proxy) {
        if (data.event && data.label) {
            trackServer({
                event: data.event,
                label: data.label,
                extra: data.extra || {},
                value: data.value || getPageUrlInfo()
            });
            return;
        }
    }
    const _data = {};
    if (data.event && data.label) {
        _data.event = data.event;
        _data.label = data.label;
        _data.extra = data.extra || {};
    } else {
        _data.event = 'web_universal';
        _data.label = 'kind';
        _data.extra = data;
    }
    onEvent(_data.event, _data.label, _data.extra);
}

const Performance = {
    timing: function(pageName) {
        if (typeof performance != 'undefined') {
            let timing = performance.timing;
            let _browserLaunching = timing.fetchStart - timing.navigationStart;
            let _preWaiting = timing.requestStart - timing.fetchStart;
            let _waitingServer = timing.responseStart - timing.requestStart;
            let _delivering = timing.responseEnd - timing.responseStart;
            let _whiteScreenTime = timing.domContentLoadedEventEnd - timing.domLoading;
            //let _loadTime=timing.loadEventEnd-timing.domLoading;
            let param = {
                pageName: pageName || '',
                event: 'timing',
                type: 'performance',
                browserLaunching: _browserLaunching,
                preWaiting: _preWaiting,
                waitingServer: _waitingServer,
                delivering: _delivering,
                whiteScreenTime: _whiteScreenTime
            };
            try {
                let timeTotal =
                    _browserLaunching +
                    _preWaiting +
                    _waitingServer +
                    _delivering +
                    _whiteScreenTime;
                if (timeTotal > 10000) {
                    param.type = 'error';
                    param.url = getPageUrlInfo();
                }
                _log(param);
            } catch (e) {
                //_log(param);
            }
        }
    },
    error: function(e, event) {
        let _now = new Date().getTime();
        //避免频繁发送
        if (now && _now - now < 1000) {
            return;
        }
        let _e;
        try {
            _e = JSON.stringify(e, ['message', 'type', 'isTrusted', 'error', 'filename']);
        } catch (ce) {
            _e = e;
        }
        const data = {
            event: 'pokeScriptError',
            type: 'error',
            e: _e
        };
        if (event) {
            data.event = event;
        }
        _log(data);
        now = _now;
    },
    log: _log
};

export {
    Performance,
    GameLog,
    onEvents,
    onEvent,
    generateExtraParams,
    onEventBeacon,
    onTalkingDataEvent
};
